import { Controller, type FieldValues } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { OtpChannelSelectorList } from '@kidslabs/mario-nextjs-react-ui-core';
import { useCallback, type ComponentProps } from 'react';
import type { OtpChannel, OtpChannelSelectorProps } from './otp-channel-selector-field.types';

export const OtpChannelSelectorField = <T extends FieldValues>({ name, control }: OtpChannelSelectorProps<T>) => {
    const { t } = useTranslation('auth');

    const otpChannels: ComponentProps<typeof OtpChannelSelectorList>['otpChannels'] = [
        {
            testID: 'sms',
            onPress: () => {},
            name: 'SMS',
            label: t('text_receive_otp_from_channel', { channel: 'SMS' }),
        },
        {
            testID: 'zalo',
            onPress: () => {},
            name: 'ZALO',
            label: t('text_receive_otp_from_channel', { channel: 'Zalo' }),
        },
    ];

    const onOptionChanged = useCallback((method: OtpChannel, onChange: (value: string) => void) => {
        onChange(method);
    }, []);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { onChange } }) => (
                <OtpChannelSelectorList
                    otpChannels={otpChannels.map(otpChannel => ({
                        ...otpChannel,
                        onPress: () => onOptionChanged(otpChannel?.name?.toUpperCase() as OtpChannel, onChange),
                    }))}
                />
            )}
        />
    );
};
